
import { HttpGetRemozeZipCodeList, HttpDeleteRemozeZipCodeOne, HttpExportRemozeZipCode } from '@/service/account';
import TableList from "@components/templates/tablelist";
import { mapGetters } from 'vuex';
import compUpload from "@components/templates/selectupload";
import mixin from "../mixin"
import compIndex from "./update";
export default {
    mixins: [TableList,mixin],
    components: {
        compIndex,
        compUpload,
    },
    data() {
        return {
            isMixin: true,
            Tools: { show: true },
            Searchs: {
                show: true,
                labelWidth: 90,
            },
            Plugins: { show: true },
            workOrderSearchList: [],
        };
    },
    methods: {
        ajaxRequest: HttpGetRemozeZipCodeList,
        handleOperates(params = "", type, batch) {
            if (batch === true) {
                params = (params || this.checkedData.join(',')) + '';
                if (!params.length) return this.$VMessage.warning(this.$t('global.common.choose_one', { defaultValue: '请选择至少一条数据' }));
            }
            switch (type) {
                case "export":
                    this.handleWebfs(HttpExportRemozeZipCode, this.formData, { executor: 'request', download: true });
                    // this.handleWebfs(
                    //     HttpExportRemozeZipCode,
                    //     this.interceptRequest(JSON.parse(JSON.stringify(this.formData))),
                    //     { executor: 'request', download: true }
                    // );
                    break;
                case "edit":
                    this.$router.push({
                        name: 'remotezipcodeUpdate',
                        params: { type: "edit" },
                        query: { id: params },
                    });
                    break;
                case "query":
                    this.operate = {
                        title: this.$t('global.common.query', { defaultValue: '查看' }),
                        show: true,
                        width: 1200,
                        component: "compIndex",
                        activeid: params,
                        querytype: 'query',
                        showFooter: false
                    }
                    break;
                case "delete":
                    this.operate = {
                        show: true,
                        alert: 'warning',
                        params: { id: params },
                        title: this.$t('global.common.delete', { defaultValue: '删除' }),
                        ajaxRequest: HttpDeleteRemozeZipCodeOne,
                        desc: this.$t('fbb.localemanage.confirm_delete', { defaultValue: '删除后不可恢复，是否确认删除？' }),
                        formdata: [
                            {
                                label: this.$t('global.common.notes', { defaultValue: '备注' }),
                                tag: "vTextarea",
                                key: 'remark',
                                span: 24,
                                labelWidth: 60,
                                required: false,
                            }
                        ]
                    }
                    break;
                case "import":
                    this.operate = {
                        show: true,
                        title: this.$t('fbb.inbound_import_data', { defaultValue: '导入数据' }),
                        width: 460,
                        showFooter: false,
                        name: "multipartFile",
                        component: "compUpload",
                        localurl:true,
                        actionurl:process.env.VUE_APP_APIURL_FBB+'/api/v2/remoteAreaZipcode/import',
                        downrul:'/static/template/account.xlsx',
                        formdata: [
                            {
                                // label: this.$t('fbb.alloment.carrier_server',{defaultValue:'承运商服务'}),\
                                label: '承运商',
                                tag: "Select",
                                key:'carrierCode',
                                options:this.getCarrierAllList.map(item=>{
                                    return {value: item.attach.carrierCode, label: item.label}
                                }),
                                props:{
                                    filterable:true,
                                },
                                labelWidth: 100,
                                span:24,
                            },
                            {
                                label: this.$tc('global.common.country',1,{defaultValue:'国家'}),
                                tag: "Select",
                                key:'regionCode',
                                options:this.getCountryList,
                                props:{
                                    filterable:true,
                                },
                                labelWidth: 100,
                                span:24,
                            },
                            {
                                label: this.$t('fbb.settlement.regionType',{defaultValue:'偏远类型'}),
                                tag: "Select",
                                key:'regionType',
                                options:this.getRemotezipType.map(item=>{
                                    return {
                                        label:item.label,
                                        value:item.number
                                    }
                                }),
                                props:{
                                    filterable:true,
                                },
                                labelWidth: 100,
                                span:24,
                            },
                        ],

                    };
                    break;
                case "queryBlank":
                    var url = this.$router.resolve({
                        name: "remotezipcodeUpdate",
                        params: { type: "query" },
                        query: { id: params },
                    });
                    window.open(url.href, '_blank');
                    break;

            }
        },
        getOperateNodeMap(row) {
            const { id } = row;
            return [
                {
                    label: this.$t('global.common.query'),
                    to: {
                        name: "remotezipcodeUpdate",
                        params: {
                            type: 'query',
                        },
                        query: { id }
                    },
                    show: true
                },
                {
                    label: this.$t('global.common.edit'),
                    params: id,
                    to: {
                        name: "remotezipcodeUpdate",
                        params: {
                            type: 'edit',
                        },
                        query: { id }
                    },
                    show: true
                },
                {
                    label: this.$t('global.common.delete', { defaultValue: '删除' }),
                    params: id,
                    operate: 'delete',
                    show: true
                },
            ];
        },
    },
    computed: {
        ...mapGetters('dictionary', ['getCountryList','getCarrierAllList' ,'getServiceAllList']),
        ToolsData() {
            return [
                {
                    label: this.$t('fbb.alloment.muti_import', { defaultValue: '批量导入' }),
                    operate: "import",
                    theme:"primary",
                },
                {
                    label: this.$t('global.common.export', { defaultValue: '导出' }),
                    operate: "export",
                    theme:"success",
                },
            ]
        },
        SearchsData() {
            return [
                {
                    label: this.$t('erp.b2c.zip_code', { defaultValue: '邮编' }),
                    key: 'EQ_zipCode',
                    tag: 'vInput',
                    show: true,
                },
                {
                    label: this.$t('fbb.settlement.regionType',{defaultValue:'偏远类型'}),
                    key: 'EQ_type',
                    tag: 'Select',
                    options:this.getRemotezipType.map(item=>{
                        return {
                            label:item.label,
                            value:item.number
                        }
                    }),
                    props:{
                        filterable:true,
                    },
                    show: true,
                },
                {
                    label: this.$t('fbb.alloment.carrier_code',{defaultValue:'承运商'}),
                    key: 'EQ_carrierCode',
                    tag: 'Select',
                    // options:this.getCarrierAllList,
                    options:this.getCarrierAllList.map(item=>{
                        return {value: item.attach.carrierCode, label: item.label}
                    }),
                    props:{
                        filterable:true,
                    },
                    show: true,
                },
                {
                    label: this.$tc('global.common.country',1,{defaultValue:'国家'}),
                    key: 'EQ_regionId',
                    tag: 'Select',
                    options:this.getCountryList.map(item=>{
                        return {
                            value:item.attach.id,
                            label:item.label
                        }
                    }),
                },

            ]
        },
        columns() {
            return [
                {
                    title: this.$t('global.common.actions', { defaultValue: '操作' }),
                    width: 100,
                    render: this.getOperateNodes
                },
                {
                    title: this.$t('erp.b2c.zip_code', { defaultValue: '邮编' }),
                    key: 'zipCode',
                },
                {
                    title: this.$t('fbb.settlement.regionType',{defaultValue:'偏远类型'}),
                    key: 'type',
                    render: (h, { row }) => this.findRenderLabel(this.getRemotezipType, row.type),
                },
                {
                    title: this.$tc('global.common.country',1,{defaultValue:'国家'}),
                    key: 'regionId',
                    render:(h,{row})=>{
                        let country = this.getCountryList.filter(item=>{return item.attach.id === Number(row.regionId)})[0] || {}
                        return country.label
                    }
                },
                {
                    title: this.$t('fbb.alloment.carrier_code',{defaultValue:'承运商'}),
                    // key: 'carrierCode',
                    // render: (h, { row }) => this.findRenderLabel(this.getCarrierAllList, row.carrierCode),
                    key: 'carrierCode',
                },
                {
                    title: this.$t('global.common.createdtime', { defaultValue: '创建时间' }),
                    key: 'createdAt',
                    render:(h,{row})=>{
                        return row.createdAt || '--'
                    }
                }];
        },
    },
};




